module.exports = __webpack_public_path__ + "img/pc_platform.3a3a26e7.svg";